<template>
	<div>
		<div class="col-12 p-0 p-md-3 mt-4 background-white cus-box-shadow rounded" v-for="(keranjang, index) in cart" :key="index">
			<div class="col-12 d-md-flex p-0 pl-lg-3 pr-lg-3 pb-3">
				<div class="col-6 pt-1 pt-md-0">
					<div class="font-size-18 font-size-sm-14 font-weight-bold f-lato"><router-link class="color-mila link-deco" :to="{ name: 'stockist' , params: { code: keranjang.stockist_code }}">{{ keranjang.stockist_code }}</router-link></div>
					<div class="font-size-14 font-size-sm-11 pt-1"><router-link class="color-black link-deco" :to="{ name: 'stockist' , params: { code: keranjang.stockist_code }}">{{ keranjang.stockist_name }}</router-link></div>
				</div>
				<div class="col-12 col-md-6 pt-1 pt-md-0 text-md-right">
					<div class="col-12 mt-2 mt-md-3 pt-1 pl-0 pr-0 pl-md-3 pr-lg-3">
						<span v-if="keranjang.stockist_origin_city_name && keranjang.stockist_origin_province_name" class="background-gray-dark no-box-shadow rounded font-size-12 font-size-sm-10 color-white p-2 pl-md-3 pr-md-3" id="lokasi-stockist">
							<font-awesome-icon :icon="['fas', 'map-marker-alt']" class="mr-2"/>
							{{ keranjang.stockist_origin_city_name }}, {{ keranjang.stockist_origin_province_name }}
						</span>
					</div>
				</div>
			</div>
			<div class="col-12 d-block d-lg-none"><div class="col-12 border-bottom"></div></div>
			<div class="col-12 pl-0 pr-0 overflow-auto">
				<div class="col-12 p-0 pl-lg-3 pr-lg-3">
					<div class="alert alert-danger" role="alert" v-if="alerts">
						<Alert class="col-12 pl-0 pr-0" empty :content="alerts"/>
					</div>
					<div class="col-12 d-none d-lg-block"><div class="col-12 border-bottom"></div></div>
					<div class="col-12 d-flex text-center font-weight-bold font-size-sm-10">
						<div class="col-8 col-md-4 pt-3 pb-3">Item</div>
						<div class="col-4 col-md-3 col-lg-2 pt-3 pb-3 text-md-right">Harga (Rp)</div>
						<div class="col-6 col-md-4 col-lg-3 pt-3 pb-3">Jumlah</div>
						<div class="col-6 col-md-3 col-lg-2 pt-3 pb-3 text-md-right">Sub Total (Rp)</div>
						<div class="col-2 col-md-1 color-red pl-0 text-right">
							<div @click="konfirmDelete({stockist_code:keranjang.stockist_code})" class="pt-3 pb-3 cursor-pointer">
								<i class="fas fa-trash"></i>
							</div>
						</div>
					</div>
					<div class="col-12 d-none d-lg-block"><div class="col-12 border-bottom"></div></div>
				</div>
				<div class="col-12 pt-2 pb-2 pl-0 pr-0 pl-lg-3 pr-lg-4 text-center font-size-sm-10" v-for="(product, indexProduct) in keranjang.products" :key="indexProduct">
					<div class="col-12 d-flex">
						<div class="col-8 col-md-4 d-flex pl-0">
							<router-link :to="{ name: 'product', params: { code: product.product_code }}" class="col-4 link-deco col-md-3 pl-0 mt-auto mb-auto"><img class="img-fluid rounded" :src="product.product_image_filename" alt=""></router-link>
							<router-link :to="{ name: 'product', params: { code: product.product_code }}" class="col-8 color-black link-deco col-md-9 mt-auto mb-auto pl-0 text-left">{{product.product_name}}</router-link>
						</div>
						<div class="col-4 col-md-3 col-lg-2 mt-auto mb-auto f-lato text-md-right"><span>{{ product.product_price | toNumber }}</span></div>
						<div class="col-6 col-md-4 col-lg-3 m-auto d-flex flex-wrap justify-content-center">
							<div class="col-12 col-md-10 col-lg-8 input-group p-0">
								<div class="input-group-prepend" id="down">
									<button :disabled="cart[index].products[indexProduct].quantity <= 1" class="btn background-purple color-white" @click="() => {cart[index].products[indexProduct].quantity--;}">
										<span class="font-size-8"><i class="fas fa-minus" ></i></span>
									</button>
								</div>
								<input @keypress="onlyNumber" v-model="cart[index].products[indexProduct].quantity" type="text" class="form-control text-center no-box-shadow font-size-12 font-size-sm-10 number box-purple" aria-label="Amount" placeholder="0">
								<div class="input-group-append" id="up">
									<button class="btn background-purple color-white" @click="() => {cart[index].products[indexProduct].quantity++;}">
										<span class="font-size-8"><i class="fas fa-plus" ></i></span>
									</button>
								</div>
							</div>
							<Alert class="col-12 pl-0 pr-0" empty :content="product.message"/>
						</div>
						<div class="col-6 col-md-3 col-lg-2 mt-auto mb-auto f-lato text-md-right">{{ parseInt(product.product_price) * product.quantity | toNumber}}</div>
						<div @click="konfirmDelete({stockist_code:keranjang.stockist_code, product_id:product.product_id, product_name:product.product_name})" class="col-2 col-md-1 mt-auto mb-auto pr-lg-2 text-right"><a class="color-red" href="javascript:;"><i class="fas fa-trash-alt"></i></a></div>
					</div>
				</div>
			</div>
			<div class="col-12">
				<div class="col-12 d-none d-lg-block"><div class="col-12 border-bottom"></div></div>
				<div class="col-12 pt-2 d-block d-lg-none border-bottom"></div>
			</div>
			<div class="col-12 d-md-flex pt-4 pl-0 pr-0 pl-lg-3 pr-lg-3">
				<div class="col-12 col-md-6 color-black">
					<div class="font-size-14 font-size-sm-11">Total</div>
					<div class="font-size-20 font-size-sm-13 f-lato">Rp {{countTotalPrice(keranjang) | toNumber}}</div>
				</div>
				<div class="col-12 col-md-6 text-right pl-0 pr-0 pl-md-3 pr-md-3">
					<div class="col-12 pt-3 pb-3 pb-md-0 pr-md-0">
						<button :disabled="progressCek" class="col-12 col-md-8 col-lg-6 btn background-button-template rounded color-white pt-2 pb-2 box-purple" @click="statusLogin(keranjang.stockist_code)">
							<span class="font-size-12 font-size-sm-10">{{isAuth ? 'Checkout' :'Proses Selanjutnya'}}</span>
							<i class="fas fa-arrow-right ml-3"></i>
						</button>
					</div>
				</div>
			</div>
		</div>

		<VModal ref="modalLogin">
			<template v-slot:header>
				<div class="modal-header no-border">
					<button class="btn btn-no-box no-border"> <img src="../../assets/modal_x.svg" class="close-modal mt-n1" @click="statusHide"></button>
				</div>
			</template>
			<template v-slot:body>

				<div class="col-12 text-center d-md-flex pt-2 pb-4 pl-0 pr-0 pl-md-3 pr-md-3">
					<div class="col-6 offset-3 offset-md-0 col-md-4 m-auto">
						<img class="img-fluid w-100" src="assets/icon/smile-woman.svg" alt="">
					</div>
					<div class="col-12 col-md-8">
						<div class="col-12 color-black font-size-14 font-size-sm-11 pt-2 pb-3 text-capitalize">
							<div>Untuk melakukan pembelian produk <br>
								Silahkan login terlebih dahulu
							</div>
						</div>
						<div class="col-12 pb-2">
							<button class="col-12 col-md-8 btn pt-2 pb-2 rounded bg-button-mitra no-box-shadow color-white text-left" @click="statusMitra">
								<i class="fas fa-sign-in-alt font-size-12 font-size-sm-9 ml-3"></i>
								<span class="col-10 font-size-14 font-size-sm-11 text-center pl-1 d-inline-block">Login</span>
							</button>
						</div>
						<div class="col-12 color-black font-size-14 font-size-sm-11">
							Atau
						</div>
						<div class="col-12 pt-2">
							<button class="col-12 col-md-8 btn pt-2 pb-2 rounded background-button-template no-box-shadow color-white text-left" @click="statusUmum">
								<i class="fas fa-user-plus font-size-12 font-size-sm-9 ml-3"></i>
								<span class="col-10 font-size-14 font-size-sm-11 text-center pl-1 d-inline-block">Daftar</span>
							</button>
						</div>
					</div>
				</div>
			</template>
			<template v-slot:footer>
				<div>
				</div>
			</template>
		</VModal>

		<VModal ref="modalUmum" class="modal-sm-70vh" modalHigh>
			<template v-slot:header>
				<div class="modal-header justify-content-center">
					<h5 class="modal-title text-uppercase">Pendaftaran</h5>
					<button class="btn btn-no-box"> <img src="../../assets/modal_x.svg" class="close-modal ml-2 mt-n1" @click="umumHide"></button>
				</div>
			</template>
			<template v-slot:body>
				<div class="col-12 text-center pt-3 pb-3 px-0 px-md-3">
					<div class="col-12 offset-md-1 col-md-10 color-black p-0 text-uppercase">lakukan pendaftaran sekarang juga dan dapatkan beragam keuntungan serta rewards khusus mitra milagros.</div>
					<div class="col-12 offset-md-1 col-md-10 px-0 px-md-3">
						<form class="mt-2">
							<div class="form-inline pt-2" v-if="!sponsorFromReferal">
								<input v-uppercase="publicData.sponsor" @change="cekSponsor" @focus="() => setAlertMandatory({code: 'sponsor', value: ''})" v-model="publicData.sponsor" class="form-control col-12 offset-md-2 col-md-8 font-size-sm-9 box-purple f-lato" type="text" placeholder="Kode Sponsor" :disabled="defaultSponsor"/>
								<div class="col-12 offset-md-2 col-md-8 font-size-10 text-left pl-0 pt-1 text-warning form-check-inline">
									<input v-model="defaultSponsor" type="checkbox" id="defaultSponsor" class="form-check-input">
									<label for="defaultSponsor" class="form-check-label">Ceklist disini untuk jadikan {{cartOne.stockist_name}} sebagai sponsor</label>
								</div>
								<Alert v-if="alertMandatory.sponsor" class="col-12 offset-md-2 col-md-8 font-size-10 font-size-sm-9 text-left pl-0" empty :content="alertMandatory.sponsor"/>
							</div>
							<div class="form-inline mt-3" v-if="dataSponsor && !sponsorFromReferal">
								<input v-model="dataSponsor" class="form-control col-12 offset-md-2 col-md-8 font-size-sm-9 box-purple f-lato" type="text" readonly />
							</div>
							<div class="col-12 offset-md-2 col-md-8 color-black text-uppercase pt-3">Detail Pribadi</div>
							<div class="form-inline pt-2">
								<div class="col-12 offset-md-2 col-md-8 font-size-14 text-left pl-0 pt-1 form-check-inline">
									<input v-model="ktpUploadShow" type="checkbox" class="form-check-input font-size-14 box-purple">
									<label for="defaultSponsor" class="form-check-label">Upload KTP</label>
								</div>
							</div>
							<div class="form-inline pt-2" v-show="ktpUploadShow == true">
								<div class="col-12 pb-1">
									Silahkan upload KTP Anda
								</div>
								<div class="col-12 box-ktp" @click="clickInputKtp">
									<img :src="ktpImage" id="ktpImage" class="image-ktp" v-show="ktpImage">
									<Alert v-if="ktpUnreadable" empty content="Mohon maaf KTP yang anda upload tidak terbaca. Mohon isi data dibawah secara manual."/>
									<div class="color-gray" v-show="!ktpImage">
										<span class="color-gray"><i class="fas fa-cloud-upload-alt fa-3x"></i></span><br>
										Upload KTP Anda
									</div>
									<input type="file" id="fileKtp" name="fileKtp" accept="image/png, image/jpeg" @change="createImage($event)" v-show="false">
								</div>
							</div>
							<div class="pt-3 d-flex cursor-pointer" @click="togglePanduan" v-if="ktpUploadShow == true">
								<div class="color-blue"><i class="fas fa-info-circle"></i></div>
								<div class="pl-1" v-if="!showPanduan">Panduan upload foto KTP</div>
								<div class="pl-1" v-else>Tutup panduan</div>
							</div>

							<div class="pt-2 justify-content-center" v-show="ktpImage && loading">
								<i class="fas fa-spinner fa-spin fa-3x"></i><br>
								Mohon tunggu...
							</div>
							<div class="form-inline pt-2" v-show="(ktpImage && !loading) || ktpUploadShow == false">
								<input @focus="() => alert.nama=''" v-model="publicData.nama" class="form-control col-12 offset-md-2 col-md-8 font-size-sm-9 box-purple" type="text" placeholder="Nama Lengkap" />
								<span v-if="!alert.nama" class="col-12 offset-md-2 col-md-8 font-size-10 text-left pl-0 pt-1 text-warning">Harus sesuai nama di rekening</span>
								<Alert v-if="alert.nama" class="col-12 offset-md-2 col-md-8 font-size-10 font-size-sm-9 text-left pl-0" empty :content="alert.nama"/>
							</div>
							<div class="form-inline mt-3" v-show="(ktpImage && !loading) || ktpUploadShow == false">
								<input @change="cekMandatory('ktp', publicData.ktpNumber)" @focus="() => setAlertMandatory({code: 'ktp', value: ''})" v-model="publicData.ktpNumber" @keypress="onlyNumber" maxlength="16" class="form-control col-12 offset-md-2 col-md-8 font-size-sm-9 box-purple f-lato" type="text" placeholder="Nomor KTP" />
								<Alert v-if="alertMandatory.ktp" class="col-12 offset-md-2 col-md-8 font-size-10 font-size-sm-9 text-left pl-0" empty :content="alertMandatory.ktp"/>
							</div>
							<div class="form-inline mt-3" v-show="(ktpImage && !loading) || ktpUploadShow == false">
								<input @focus="() => alert.email=''" v-model="publicData.email" class="form-control col-12 offset-md-2 col-md-8 font-size-sm-9 box-purple f-lato" type="text" placeholder="Alamat Email" />
								<Alert class="col-12 offset-md-2 col-md-8 font-size-10 font-size-sm-9 text-left pl-0" empty :content="alert.email"/>
							</div>
							<div class="form-inline mt-3" v-show="(ktpImage && !loading) || ktpUploadShow == false">
								<input @change="cekMandatory('hp', publicData.phone)" @focus="() => setAlertMandatory({code: 'phone', value: ''})" v-model="publicData.phone" @keypress="onlyNumber" maxlength="15" class="form-control col-12 offset-md-2 col-md-8 font-size-sm-9 box-purple f-lato" type="text" placeholder="Nomor Handphone" />
								<Alert v-if="alertMandatory.phone" class="col-12 offset-md-2 col-md-8 font-size-10 font-size-sm-9 text-left pl-0" empty :content="alertMandatory.phone"/>
							</div>
						</form>
					</div>
					<div class="pt-2 col-12 offset-md-1 col-md-10 px-0 px-md-3 text-left ktp-guide" v-if="showPanduan">
						<div class="d-flex flex-wrap">
							<div class="col-12 col-md-6 pl-0 pr-0 pr-md-3">
								<div><img class="img-fluid w-100" src="/assets/icon/ktp-1.svg"></div>
								<div class="pt-2 d-flex flex-wrap justify-content-center">
									<div class="col-6 px-0">
										<div class="pr-1"><img class="img-fluid w-100" src="/assets/icon/ktp-2.svg"></div>
									</div>
									<div class="col-6 px-0">
										<div class="pl-1"><img class="img-fluid w-100" src="/assets/icon/ktp-3.svg"></div>
									</div>
									<div class="pt-2 col-6 px-0">
										<div><img class="img-fluid w-100" src="/assets/icon/ktp-4.svg"></div>
									</div>
								</div>
							</div>
							<div class="col-12 col-md-6 px-0 px-md-3 my-auto">
								<div class="pt-3 pt-md-0 d-flex">
									<div>&#8226;</div>
									<div class="pl-1">Pastikan keseluruhan KTP terlihat jelas pada foto.</div>
								</div>
								<div class="pt-3 d-flex">
									<div>&#8226;</div>
									<div class="pl-1">Pastikan foto tidak buram/blur.</div>
								</div>
								<div class="pt-3 d-flex">
									<div>&#8226;</div>
									<div class="pl-1">Pastikan tidak ada pantulan cahaya pada KTP.</div>
								</div>
								<div class="pt-3 d-flex">
									<div>&#8226;</div>
									<div class="pl-1">Pastikan pencahayaan cukup.</div>
								</div>
								<div class="pt-3 d-flex">
									<div>&#8226;</div>
									<div class="pl-1">Pastikan teks pada KTP dapat terbaca jelas.</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
			<template v-slot:footer>
				<div class="modal-footer justify-content-center">
					<button class="col-12 col-md-3 btn pt-2 pb-2 rounded background-button-template no-box-shadow color-white text-center" @click="asPublic()" :disabled="validate_progress">
						<span class="font-size-11 font-weight-bold text-capitalize">Selanjutnya</span>
						<i class="fas fa-arrow-right ml-3"></i>
					</button>
				</div>
			</template>
		</VModal>

		<VModal ref="modalMitra" class="modal-small">
			<template v-slot:header>
				<div class="modal-header no-border">
					<button class="btn btn-no-box no-border"> <img src="../../assets/modal_x.svg" class="close-modal mt-n1" @click="mitraHide"></button>
				</div>
			</template>
			<template v-slot:body>
				<LoginComponent :showRegister="true" @register="statusUmum"/>
			</template>
			<template v-slot:footer>
				<div>
				</div>
			</template>
		</VModal>

		<VModal ref="modalEmail" class="modal-small">
			<template v-slot:header>
				<div class="modal-header no-border">
					<button class="btn btn-no-box no-border"> <img src="../../assets/modal_x.svg" class="close-modal mt-n1" @click="() => $refs.modalEmail.modalHide()"></button>
				</div>
			</template>
			<template v-slot:body>
				<div class="col-12 text-center pt-3 pb-3">
					<div class="col-12 offset-md-2 col-md-8 color-black p-0 text-uppercase">mohon masukan email anda agar pesanan ini dapat diproses</div>
					<form class="mt-2">
						<div class="form-inline pt-2">
							<input @focus="() => alertEmail = ''" v-model="dataEmail" class="form-control col-12 offset-md-2 col-md-8 font-size-sm-9 box-purple" type="text" placeholder="Email" />
							<Alert v-if="alertEmail" class="col-12 offset-md-2 col-md-8 font-size-10 font-size-sm-9 text-left pl-0" empty :content="alertEmail"/>
						</div>
					</form>
				</div>
			</template>
			<template v-slot:footer>
				<div class="modal-footer justify-content-center">
					<button class="col-12 col-md-4 btn pt-2 pb-2 rounded background-button-template no-box-shadow color-white text-center" @click="inputEmail">
						<span class="font-size-11 font-weight-bold text-capitalize">Selanjutnya</span>
						<i class="fas fa-arrow-right ml-3"></i>
					</button>
				</div>
			</template>
		</VModal>

		<VModal ref="konfirmasiDelete" class="modal-small">
			<template v-slot:header>
				<div></div>
			</template>
			<div slot="body" class="col-12 mb-3">
				<div class="col-12 d-md-flex">
					<div class="col-5 m-auto pt-md-3 pl-0 pl-md-3 pr-md-3 pr-0">
						<img class="img-fluid" src="/assets/icon/surprise-woman.svg">
					</div>
					<div class="col-12 col-md-7 pt-3 color-black m-auto text-md-left text-center pl-0 pr-0 pl-md-3 pr-md-3">
						<div class="font-bold font-size-sm-12">Hapus Dari Keranjang</div>
						<div v-if="!paramDeleteCart.product_name" class="font-size-sm-11 pt-2">Apakah Anda yakin akan menghapus pesanan ini?</div>
						<div v-else class="mr-n3 font-size-sm-11 pt-2">Apakah Anda yakin akan menghapus {{paramDeleteCart.product_name}}?</div>
					</div>
				</div>
			</div>
			<div slot="footer">
				<div class="modal-footer justify-content-center justify-content-md-end">
					<button class="col-6 col-md-3 btn btn-outline-danger rounded mr-1 font-size-sm-9 pr-md-4 pl-md-4 text-capitalize box-purple" type="button" @click="()=> {$refs.konfirmasiDelete.modalHide(); resetData();}">
						<i class="fa fa-times mr-1"></i>Batal
					</button>
					<button class="col-6 col-md-3 btn background-button-template color-white rounded font-size-sm-9 pr-md-4 pl-md-4 text-capitalize" type="button" @click="() => {$refs.konfirmasiDelete.modalHide(); deleteCart(paramDeleteCart)}">
						<i class="fa fa-check mr-1"></i>Ya
					</button>
				</div>
			</div>
		</VModal>
	</div>

</template>
<script>
import { client } from '@/api/client';
import qs from 'qs';
import interceptors from '@/api/interceptors';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import validator from 'validator'
import Alert from '@/components/Alert';
import VModal from '@/components/VModal';
import LoginComponent from '@/views//LoginComponent';
import authHelper from '@/helpers/auth';
import ktpHelper from '@/helpers/ktp';
import $ from 'jquery';
import { createWorker } from 'tesseract.js';

const worker = createWorker();


export default {
	name: 'ListProduct',
	components:{
		Alert, VModal, LoginComponent
	},
	props:{
		publicData:{
			type: Object
		},
	},
	data(){
		return {
			ktpUploadShow: false,
			showPanduan: false,
			dataSponsor:'',
			dataEmail: '',
			alertEmail:'',
			selected_stockist_code : '',
			alert : {
				sponsor : '',
				nama : '',
				email : '',
			},
			paramDeleteCart:'',
			progressCek: false,
			defaultSponsor: false,
			camera: [],
			textfromcamera: '',
			ktpImage: '',
			ktpUnreadable: false,
			loading: false,
			validate_progress: false,
			sponsorFromReferal: '',
			prospectData: '',
		}
	},
	computed : {
		...mapState('cart', ['cart', 'step', 'alertMandatory', 'cartOne', 'alerts']),
		...mapState('auth', ['userData']),
		...mapGetters('auth', ['isAuth']),

		disabledDates(){
			var disable = {
				from: new Date(this.today.setFullYear(this.today.getFullYear()-17))
			}
			return disable;
		},
	},
	methods: {
		...mapMutations('auth', ['setUserData']),
		...mapMutations('cart' , ['step_up', 'setAlertMandatory', 'setSponsorMLM']),
		...mapActions('address', ['getProvinces', 'getCity', 'getDistrict']),
		...mapActions('cart', ['searchCart', 'deleteCart', 'checkCart', 'validateData']),
		...mapActions('stockist', ['getStockistDetail']),


		countTotalPrice(data) {
			let total = 0
			data.products.forEach(el => {
				total += el.quantity * el.product_price
			})
			return total
		},
		togglePanduan() {
			if (this.showPanduan) {
				this.showPanduan = !this.showPanduan
			}
			else {
				this.showPanduan = true
				$(".modal-dialog-centered .body-modal").animate({ scrollTop: 600 }, "slow");
			}
		},
		clickInputKtp() {
			document.getElementById('fileKtp').click()
		},
		async createImage(event) {
			var reader = await new FileReader();
			reader.onload = () => {
				this.ktpImage = reader.result
			};
			await reader.readAsDataURL(event.target.files[0])
			await this.recognize()
		},
		async recognize() {
			this.ktpUnreadable = await false
			this.publicData.ktpNumber = await '';
			this.publicData.nama = await '';
			this.loading = await true;
			const img = await document.getElementById('ktpImage');
			await worker.load();
			await worker.loadLanguage('ind');
			await worker.initialize('ind');
			// await worker.setParameters({
			// 	tessedit_pageseg_mode: PSM.PSM_AUTO_ONLY,
			// });
			const { data: { text } } = await worker.recognize(img);
			this.textfromcamera = text
			let array_text = text.split("\n")
			let nik = ''
			let nama = ''
			nik = array_text.find( (el) => {
				return el.includes('NIK')
			})
			if (nik)
				this.publicData.ktpNumber = nik.replace(/[^0-9]/g, '');

			nama = array_text.find( (el) => {
				return el.includes('Nama')
			})
			if (nama)
				this.publicData.nama = nama.replace(/Nama|[^a-z ]/ig, '').trim();

			if (!nik && !nama) {
				this.ktpUnreadable = true
				ktpHelper.clearData()
			} else {
				ktpHelper.setData({
					img: this.ktpImage,
					nama: this.publicData.nama,
					nik: this.publicData.ktpNumber
				})
			}

			await this.resetAlert()
			this.loading = await false
		},
		konfirmDelete(val) {
			this.paramDeleteCart = val
			this.$refs.konfirmasiDelete.modalShow()
		},
		resetData() {
			this.paramDeleteCart = ''
		},
		cekSponsor(){
			this.dataSponsor = ''
			if (this.publicData.sponsor) {
				this.$store.commit('PROGRESS_START')
				client.interceptors.request.use(interceptors.noAuth, interceptors.onError);
				client.get('/tunnel/api/public/transaction/check_sponsor', {
					params: {
						sponsor_mid: this.publicData.sponsor
					}
				}).then(({ data: { data } }) => {
					this.setSponsorMLM(data)
					this.setAlertMandatory({code: 'sponsor', value: ''})
					this.dataSponsor = data.member_name
					if (data.city) {
						this.dataSponsor += ` (${data.city})`
					}
					this.$store.commit('PROGRESS_FINISH')
				}).catch((err) => {
					this.setSponsorMLM({})
					const { data } = err.response
					this.setAlertMandatory({code: 'sponsor', value: data.message})
					this.$store.commit('PROGRESS_FAIL')
				});
			}
		},
		resetAlert() {
			this.setAlertMandatory({code: 'ktp', value: ''})
			this.setAlertMandatory({code: 'phone', value: ''})
			this.alert.nama = ''
			this.alert.email = ''
		},
		cekMandatory(type, data) {
			if (type == 'ktp') {
				if (data.length != 16) {
					this.alert.ktpNumber = "Format tidak valid";
				} else {
					this.$store.commit('PROGRESS_START')
					client.interceptors.request.use(interceptors.noAuth, interceptors.onError);
					client.get('/tunnel/api/public/registration/mandatory_check', {
						params: {
							type: 'ktp',
							data: data
						}
					}).then(() => {
						this.setAlertMandatory({code: 'ktp', value: ''})
						this.$store.commit('PROGRESS_FINISH')
					}).catch((err) => {
						const { data } = err.response
						this.setAlertMandatory({code: 'ktp', value: data.message})
						this.$store.commit('PROGRESS_FAIL')
					});
				}
			} else if (type == 'hp') {
				if (!validator.isLength(this.publicData.phone , {min:10 , max:14})) {
					this.alert.ktpNumber = "Nomor HP tidak valid";
				} else {
					this.$store.commit('PROGRESS_START')
					client.interceptors.request.use(interceptors.noAuth, interceptors.onError);
					client.get('/tunnel/api/public/registration/mandatory_check', {
						params: {
							type: 'hp',
							data: data
						}
					}).then(() => {
						this.setAlertMandatory({code: 'phone', value: ''})
						this.$store.commit('PROGRESS_FINISH')
					}).catch((err) => {
						const { data } = err.response
						this.setAlertMandatory({code: 'phone', value: data.message})
						this.$store.commit('PROGRESS_FAIL')
					});
				}
			}
		},
		inputEmail(){
			if (!this.dataEmail) {
				this.alertEmail = 'Email tidak boleh kosong'
			} else if (!validator.isEmail(this.dataEmail)) {
				this.alertEmail = 'Email tidak valid'
			} else {
				let dataMember = Object.assign({}, this.userData);
				dataMember.member_email = this.dataEmail
				this.alertEmail = ''
				this.$store.commit('PROGRESS_START')
				client.interceptors.request.use(interceptors.auth, interceptors.onError);
				client.post('/tunnel/api//member/common/updateemail', qs.stringify({
					member_network_mid: this.userData.member_network_mid,
					member_email: this.dataEmail,
				}), {
					header: {
						'Content-Type': 'application/x-www-form-urlencoded'
					},
				}).then(() => {
					this.$refs.modalEmail.modalHide()
					authHelper.setData({
						member: dataMember,
						token: authHelper.getToken()
					})
					this.setUserData()
					this.step_up()
					this.$store.commit('PROGRESS_FINISH')
				}).catch(() => {
					this.$store.commit('PROGRESS_FAIL')
				});
			}
		},
		statusLogin(code) {
			this.progressCek = true
			this.checkCart(this.cart).then(() => {
				this.progressCek = false
				const data = this.cart.find((element)=> {
					return element.products.find((el) => el.message !== "")
				})
				if (!data) {
					this.selected_stockist_code = code
					this.getStockistDetail(this.selected_stockist_code)
					this.searchCart(this.selected_stockist_code)
					if(!this.isAuth){
						// this.$refs.modalLogin.modalShow()
						if (!this.alerts && !this.prospectData) {
							this.statusMitra()
						} else if (!this.alerts && this.prospectData) {
							this.statusUmum()
						}
					} else {
						if (this.userData.member_email) {
							this.step_up()
						} else {
							this.$refs.modalEmail.modalShow()
						}
					}
				}
			})
		},
		statusHide() {
			this.$refs.modalLogin.modalHide()
		},
		async statusUmum() {
			let ktpData = await ktpHelper.getData()
			if (ktpData) {
				this.ktpImage = await ktpData.img
				this.publicData.ktpNumber = await ktpData.nik
				this.publicData.nama = await ktpData.nama
			}
			await this.mitraHide()
			await this.$refs.modalUmum.modalShow()
		},
		async asPublic() {
			this.validate_progress = await true
			if (!this.publicData.nama) {
				this.alert.nama = 'Nama tidak boleh kosong'
			} else {
				this.alert.nama = ''
			}
			if (!this.publicData.email) {
				this.alert.email = 'Email tidak boleh kosong'
			} else if (!validator.isEmail(this.publicData.email)) {
				this.alert.email = 'Email tidak valid'
			} else {
				this.alert.email = ''
			}

			if (!this.publicData.phone) {
				this.setAlertMandatory({code: 'phone', value: 'Nomor Handphone tidak boleh kosong'})
			} else if(!validator.isLength(this.publicData.phone , {min:10 , max:15})){
				this.setAlertMandatory({code: 'phone', value: 'Nomor Handphone tidak valid'})
			} else {
				this.setAlertMandatory({code: 'phone', value: ''})
			}

			if (!this.publicData.sponsor) {
				this.setAlertMandatory({code: 'sponsor', value: 'Kode Sponsor tidak boleh kosong'})
			} else {
				this.setAlertMandatory({code: 'sponsor', value: ''})
			}
			if (!this.publicData.ktpNumber) {
				this.setAlertMandatory({code: 'ktp', value: 'Nomor KTP tidak boleh kosong'})
			} else if (this.publicData.ktpNumber.length !== 16) {
				this.setAlertMandatory({code: 'ktp', value: 'Nomor KTP tidak valid'})
			} else {
				this.setAlertMandatory({code: 'ktp', value: ''})
			}
			if (!this.alert.nama && !this.alertMandatory.phone && !this.alertMandatory.sponsor && !this.alertMandatory.ktp && !this.alert.email) {
				await this.validateData({sponsor: this.publicData.sponsor, ktp: this.publicData.ktpNumber, phone: this.publicData.phone, stockist_code: this.selected_stockist_code})
			}
			this.validate_progress = await false
		},
		umumHide() {
			this.$refs.modalUmum.modalHide()
		},
		statusMitra() {
			this.$refs.modalMitra.modalShow()
		},
		mitraHide() {
			this.$refs.modalMitra.modalHide()
		},
	},
	watch: {
		step(val){
			if (val > 1) {
				this.$refs.modalUmum.modalHide()
				this.$refs.modalLogin.modalHide()
			}
		},
		defaultSponsor(val) {
			if (val) {
				this.publicData.sponsor = this.cartOne.stockist_network_mid
				this.cekSponsor()
			}
		}
	},
	mounted() {
		// get data sponsor
		let sponsorReferal = JSON.parse(localStorage.getItem('sponsor_data'));
		this.sponsorFromReferal = sponsorReferal ? sponsorReferal : ''
		this.publicData.sponsor = this.sponsorFromReferal.network_mid
		this.dataSponsor = this.sponsorFromReferal.member_name
		if (this.sponsorFromReferal.city) {
			this.dataSponsor += ` (${this.sponsorFromReferal.city})`
		}
		
		// get data prospek
		this.prospectData = JSON.parse(localStorage.getItem('prospect_data'));
		if (this.prospectData) {
			this.publicData.nama = this.prospectData.name
			this.publicData.email = this.prospectData.email
			this.publicData.phone = this.prospectData.mobilephone
		}
		
	}
}
</script>

<style scoped>
.error::placeholder {
	color: red !important;
}
.show-password {
	right: 1.5rem;
}
.box-ktp {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	border: 1px dashed #000;
	border-radius: 10px;
	width: 100%;
	height: 280px;
	background-color: #fff;
	cursor: pointer;
	position: relative;
}
.image-ktp {
	max-height: 80%;
	max-width: 80%;
}
</style>